import React from 'react';

import { ReportToast, ReportTextContainer, ReportTitle, ReportInfo } from './styles';

export default function DownloadPdfReportToast() {
  return (
    <ReportToast>
      <i className="fa fa-spinner fa-spin"></i>
      <ReportTextContainer>
        <ReportTitle>Generating PDF report</ReportTitle>
        <ReportInfo>Download starts in a few seconds</ReportInfo>
      </ReportTextContainer>
    </ReportToast>
  );
}
